<template>
    <vue-draggable-resizable
        :x="layer.x"
        :y="layer.y"
        :w="layer.width"
        :h="layer.height"
        :scale="zoom"
        :active="layer.active"
        :style="computedTransformStyle"
        class="overlay-layer"
        :class="{ bordered: edit }"
        @resizing="onResizing"
        @dragging="onDragging"
        @activated="onActivated"
        @deactivated="onDeactivated"
        :preventDeactivation="true"
        v-if="zoom"
        >
        <div :style="computedStyle" v-html="layerValue" :class="layerClass">
        </div>

    </vue-draggable-resizable>
</template>
<script>
import VueDraggableResizable from 'vue-draggable-resizable';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';

export default {
  name: 'OverlayComponent',
  components: {
    VueDraggableResizable,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    zoom: {
      type: Number,
      required: true,
    },
    layer: {
      type: Object,
      required: true,
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    layerClass() {
      if (this.layer.animation) {
        return `animate__animated animate__${this.layer.animation}`;
      }
      return '';
    },
    layerValue() {
      if (this.layer.value !== undefined && this.layer.value !== null) {
        if (this.layer.type === 'title') {
          return this.layer.value.replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll(/\n/g, '<br>');
        }
        if (this.layer.type === 'video') {
          return `<video src="${this.layer.value}" controls style="max-width: 100%; max-height: 100%;"></video>`;
        }
      }
      return '';
    },
    computedTransformStyle() {
      const translate = `translate(${this.layer.x || 0}px, ${this.layer.y || 0}px)`;
      const rotate = `rotate(${this.layer.rotation || 0}deg)`;

      // Combine them into a single transform string
      return { transform: `${translate} ${rotate}` };
    },
    computedStyle() {
      return {
        opacity: this.layer.opacity / 100,
        fontFamily: this.layer.font,
        fontSize: `${this.layer.fontSize}px`,
        color: this.layer.color,
        lineHeight: this.layer.lineHeight,
        textAlign: this.layer.alignment,
        fontWeight: this.layer.bold ? 'bold' : 'normal',
        fontStyle: this.layer.italic ? 'italic' : 'normal',
        textDecoration: this.layer.underline ? 'underline' : 'none',
        textShadow: this.layer.shadow ? this.layer.shadowStyle : 'none',
        wordWrap: 'break-word',
        overflow: 'hidden',
        height: `${this.layer.height}px`,
      };
    },
  },
  methods: {
    onResizing(x, y, width, height) {
      this.$emit('update-layer', {
        data: {
          ...this.layer, x, y, width, height,
        },
        source: 'layer',
        index: this.index,
      });
    },
    onDragging(x, y) {
      this.$emit('update-layer', {
        data: {
          ...this.layer, x, y,
        },
        source: 'layer',
        index: this.index,
      });
    },
    onActivated() {
      this.$emit('activate-layer', this.index);
    },
    onDeactivated() {
      this.$emit('deactivate-layer', this.index);
    },
  },
};
</script>
<style scoped>
.overlay-layer {
  position: absolute;
  display: block;
}

.bordered {
  border: 3px dotted black;
}
</style>
